import React, { ReactNode } from "react";
import { Box, Typography, Button } from "@mui/material";
import { SearchInput } from "../SearchInput";

interface PageHeaderProps {
  title: string;
  onSearch: (value: string) => void;
  onAdd?: () => void;
  children?: ReactNode;
}

export function PageHeader({ title, onSearch, onAdd, children }: PageHeaderProps) {
  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", mb: 4, pr: 3, gap: 2 }}>
      <Typography variant="h5" sx={{ flex: 1, pl: 3, pt: 2, minWidth: "150px" }}>
        {title}
      </Typography>
      <SearchInput onSearch={onSearch} />
      {children}
      {onAdd && (
        <Button variant="contained" sx={{ mr: 2 }} onClick={onAdd}>
          Hinzufügen
        </Button>
      )}
    </Box>
  );
}
